import styled from "styled-components";
import {FlexContainerBox} from "../../../../../../../../themes/architecture/css-helpers/flex";

export const FooterContainerBox = styled(FlexContainerBox)`
    width: 100%;
    padding: 2px;
    color: ${props => props.theme.colors.text};
    font-size: 1.4rem;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {  
      font-size: 1.1rem;
    }
`